// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yiad","title":"styles_title__1mN6Q"};